module.exports = __webpack_public_path__ + "static/media/onesaz.c46441cf.png";